import React from 'react'
import { useLocation } from 'react-router-dom'
import { Form, Col, Button } from 'react-bootstrap'
import { useFieldArray, useFormContext } from 'react-hook-form'
import CustomInput from './CustomInput'
import { useAppendOne } from './Hooks'

function Directivos() {
  const { register, errors, watch, control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'directivos'
  })

  const location = useLocation()

  useAppendOne(
    true,
    fields,
    append,
    {
      nombre: '',
      cargo: '',
      fecha_desde: '',
      fecha_hasta: '',
      domicilio_calle: '',
      domicilio_numero: '',
      domicilio_piso: '',
      domicilio_cp: '',
      domicilio_localidad: '',
      email: '',
      cargo_vigente: true
    },
    true
  )

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mt-3">
        Integrantes del órgano de administración
      </h6>
      <hr className="mb-4" />

      {fields.length > 0 &&
        fields.map((field, index) => (
          <React.Fragment key={field.id}>
            <Form.Row>
              <CustomInput
                md={6}
                label={`Apellido y nombre ${index + 1}`}
                placeholder="Ingrese apellido y nombre"
                type="text"
                name={`directivos[${index}].nombre`}
                errorPath={errors?.directivos?.[index]?.nombre}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar el nombre.'
                  }
                }}
                defaultValue={field.nombre}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              <CustomInput
                md={6}
                label={`CUIL / DNI ${index + 1}`}
                placeholder="Ingrese CUIL"
                type="number"
                name={`directivos[${index}].cuil`}
                errorPath={errors?.directivos?.[index]?.cuil}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar la CUIL o DNI.'
                  },
                  minLength: {
                    value: 11,
                    message: 'La CUIL debe ser de 11 dígitos.'
                  },
                  maxLength: {
                    value: 11,
                    message: 'La CUIL debe ser de 11 dígitos.'
                  },
                  pattern: {
                    value: /^\d+$/,
                    message: 'Sólo puede incluir números.'
                  }
                }}
                defaultValue={field.cuil}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />
            </Form.Row>

            <Form.Row>
              <CustomInput
                md={4}
                label={`Cargo ${index + 1}`}
                placeholder="Ingrese cargo"
                type="text"
                name={`directivos[${index}].cargo`}
                errorPath={errors?.directivos?.[index]?.cargo}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar el cargo.'
                  }
                }}
                defaultValue={field.cargo}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              <Col md={2} className="pt-4">
                <Form.Group className="custom-control custom-checkbox custom-control-inline">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    id="checkbox-cargo-vigente"
                    ref={register({ required: false })}
                    name={`directivos[${index}].cargo_vigente`}
                    defaultChecked={field.cargo_vigente}
                    disabled={
                      location?.state?.visualizarDatos ||
                      location?.state?.modificarDatos
                    }
                  />
                  <Form.Label
                    className="custom-control-label"
                    htmlFor="checkbox-cargo-vigente"
                  >
                    Cargo vigente {index + 1}
                  </Form.Label>
                </Form.Group>
              </Col>

              <CustomInput
                md={3}
                label={`Desde ${index + 1}`}
                as="input"
                type="date"
                min="1900-01-01"
                max="3000-12-31"
                name={`directivos[${index}].fecha_desde`}
                errorPath={errors?.directivos?.[index]?.fecha_desde}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar la fecha.'
                  }
                }}
                defaultValue={field.fecha_desde}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              {!watch(`directivos[${index}].cargo_vigente`) && (
                <CustomInput
                  md={3}
                  label={`Hasta ${index + 1}`}
                  as="input"
                  type="date"
                  min="1900-01-01"
                  max="3000-12-31"
                  name={`directivos[${index}].fecha_hasta`}
                  errorPath={errors?.directivos?.[index]?.fecha_hasta}
                  validation={{
                    required: {
                      value: false,
                      message: 'Es necesario ingresar la fecha.'
                    }
                  }}
                  defaultValue={field.fecha_hasta}
                  disabled={
                    location?.state?.visualizarDatos ||
                    location?.state?.modificarDatos
                  }
                />
              )}
            </Form.Row>

            <Form.Row>
              <CustomInput
                md={6}
                label={`Domicilio ${index + 1}`}
                placeholder="Ingrese la calle"
                type="text"
                name={`directivos[${index}].domicilio_calle`}
                errorPath={errors?.directivos?.[index]?.domicilio_calle}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar la calle.'
                  }
                }}
                defaultValue={field.domicilio_calle}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              <CustomInput
                md={3}
                label="Número"
                placeholder="Número"
                type="number"
                name={`directivos[${index}].domicilio_numero`}
                errorPath={errors?.directivos?.[index]?.domicilio_numero}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar el número.'
                  }
                }}
                defaultValue={field.domicilio_numero}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />
              <CustomInput
                md={3}
                label="Piso"
                placeholder="Piso"
                name={`directivos[${index}].domicilio_piso`}
                errorPath={errors?.directivos?.[index]?.domicilio_piso}
                validation={{ required: false }}
                defaultValue={field.domicilio_piso}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />
            </Form.Row>

            <Form.Row>
              <CustomInput
                label="Localidad"
                placeholder="Ingrese la localidad"
                md={6}
                type="text"
                name={`directivos[${index}].domicilio_localidad`}
                errorPath={errors?.directivos?.[index]?.domicilio_localidad}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar la localidad.'
                  }
                }}
                defaultValue={field.domicilio_localidad}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              <CustomInput
                md={6}
                label="C.P."
                placeholder="Código postal"
                type="text"
                name={`directivos[${index}].domicilio_cp`}
                errorPath={errors?.directivos?.[index]?.domicilio_cp}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar el código postal.'
                  }
                }}
                defaultValue={field.domicilio_cp}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />
            </Form.Row>

            <Form.Row>
              <CustomInput
                md={6}
                label={`E-mail ${index + 1}`}
                placeholder="Ingrese un E-mail válido"
                type="text"
                name={`directivos[${index}].email`}
                errorPath={errors?.directivos?.[index]?.email}
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar un email.'
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Dirección email inválida.'
                  }
                }}
                defaultValue={field.email}
                disabled={
                  location?.state?.visualizarDatos ||
                  location?.state?.modificarDatos
                }
              />

              {index >= 1 && (
                <Button
                  className="ml-auto d-block mt-4"
                  variant="outline-secondary"
                  onClick={() => remove(index)}
                  disabled={
                    location?.state?.visualizarDatos ||
                    location?.state?.modificarDatos
                  }
                >
                  Eliminar integrante {index + 1}
                </Button>
              )}
            </Form.Row>

            <hr className="my-2" />
          </React.Fragment>
        ))}

      {fields.length < 5 && (
        <Form.Row>
          <Button
            variant="outline-primary"
            className="btn-block my-4"
            onClick={() => append()}
            disabled={
              location?.state?.visualizarDatos ||
              location?.state?.modificarDatos
            }
          >
            Agregar integrante
          </Button>
        </Form.Row>
      )}
    </>
  )
}

export default Directivos
